import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import { resetAskSignup } from "../../app/features/user/userSlice";
import AppModal from "./AppModal";

const AuthModal = () => {
  let user = useSelector((state) => state.user.user);
  const askSignup = useSelector((state) => state.user.askSignup);

  const dispatch = useDispatch();
  const handleModalClose = async () => {
    dispatch(resetAskSignup());
  };

  return (
    <AppModal id="authModal" onClose={() => handleModalClose}>
      {!user && !askSignup && <LoginForm />}
      {!user && askSignup && <SignupForm />}
    </AppModal>
  );
};

export default AuthModal;
